import type { TFunction } from 'i18next'

import {
  showManagerClientContacts,
} from './detail-visibility'

export const CLIENT_CONTACT_FIELD_KEYS = [
  'client_contact_name',
  'client_contact_phone',
  'client_contact_email',
] as const

export const EXECUTOR_CONTACT_FIELD_KEYS = [
  'executor_manager_name',
  'executor_manager_phone',
  'executor_manager_email',
] as const

export type ClientContactFieldKey = typeof CLIENT_CONTACT_FIELD_KEYS[number]
export type ExecutorContactFieldKey = typeof EXECUTOR_CONTACT_FIELD_KEYS[number]

export function buildClientContactFields(
  values: ClientContactFormValues,
  t: TFunction,
): ApplicationContactFieldView[] {
  return [
    {
      key: 'client_contact_name',
      label: t('applications__text__acceptProposalContactName'),
      value: values.client_contact_name,
    },
    {
      key: 'client_contact_phone',
      label: t('applications__text__acceptProposalContactPhone'),
      value: values.client_contact_phone,
    },
    {
      key: 'client_contact_email',
      label: t('applications__text__acceptProposalContactEmail'),
      value: values.client_contact_email,
    },
  ]
}

export function buildExecutorContactFields(
  values: RevealContactsFormValues,
  t: TFunction,
): ApplicationContactFieldView[] {
  return [
    {
      key: 'executor_manager_name',
      label: t('applications__text__managerName'),
      value: values.executor_manager_name,
    },
    {
      key: 'executor_manager_phone',
      label: t('applications__text__managerPhone'),
      value: values.executor_manager_phone,
    },
    {
      key: 'executor_manager_email',
      label: t('applications__text__managerEmail'),
      value: values.executor_manager_email,
    },
  ]
}

export function clientContactFormFromApp(app: ApplicationDetail): ClientContactFormValues {
  return {
    client_contact_name: app.client_contact_name || '',
    client_contact_phone: app.client_contact_phone || '',
    client_contact_email: app.client_contact_email || '',
  }
}

export function executorContactFormFromApp(app: ApplicationDetail): RevealContactsFormValues {
  return {
    executor_manager_name: app.executor_manager_name || '',
    executor_manager_phone: app.executor_manager_phone || '',
    executor_manager_email: app.executor_manager_email || '',
  }
}

export function clientContactsDirty(
  form: ClientContactFormValues,
  app: ApplicationDetail,
): boolean {
  return CLIENT_CONTACT_FIELD_KEYS.some((key) => (
    (form[key] || '').trim() !== (app[key] || '').trim()
  ))
}

export function executorContactsDirty(
  form: RevealContactsFormValues,
  app: ApplicationDetail,
): boolean {
  return EXECUTOR_CONTACT_FIELD_KEYS.some((key) => (
    (form[key] || '').trim() !== (app[key] || '').trim()
  ))
}

export function shouldShowClientContactsBlock(
  app: ApplicationDetail,
  managerView: boolean,
): boolean {
  return showManagerClientContacts({ app, managerView })
}
